import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { ExActions, ExMutations } from "@/exstore/ExStoreEnums";
import ExApiService from "@/excore/ExApiService";
import { ErrorPopup } from "@/excore/Popup";
import ExJwtService from "@/excore/ExJwtService";

export enum UserRole {
  Admin = 1,
  AreaAdmin = 2,
  CityAdmin = 3,
  DistrictAdmin = 4,
  Guest,
  GeneralResponsible,
}

export interface User {
  id: number;
  name: string;
  tc: string;
  phone: string;
  email: string;
  user_type: UserRole;
  is_active: boolean;
  birth_day: string;
  signature_url: string;
  country_id: number | null;
  city_id: number | null;
  district_id: number | null;
  address: string;
}

export interface ExUserAuthInfo {
  user: User;
  isAuthenticated: boolean;
}

@Module
export default class ExAuthModule extends VuexModule implements ExUserAuthInfo {
  user = {} as User;
  isAuthenticated = !!ExJwtService.getAccessToken();

  get currentUser(): User {
    return this.user;
  }
  get GetRole(): UserRole {
    return this.user.user_type;
  }

  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  @Mutation
  [ExMutations.SET_AUTH](isAuthenticated) {
    this.isAuthenticated = isAuthenticated;
  }

  @Mutation
  [ExMutations.SET_USER](user: User) {
    this.user = user;
  }

  @Mutation
  [ExMutations.LOGOUT]() {
    const url = process.env.VUE_APP_API_URL + "/auth";
    this.isAuthenticated = false;
    this.user = {} as User;
    ExJwtService.destroyTokens();
    document.location.href = url;
  }

  @Action
  async [ExActions.LOGIN]({ access_token, refresh_token }) {
    ExJwtService.saveTokens(access_token, refresh_token);

    this.context.commit(ExMutations.SET_AUTH, true);
    await this.context.dispatch(ExActions.UPDATE_USER);
    await this.context.dispatch(ExActions.UPDATE_SEPET);
  }

  @Action
  async [ExActions.LOGOUT]() {
    const AccessToken = ExJwtService.getAccessToken();
    const RefreshToken = ExJwtService.getRefreshToken();
    const [error, resp] = await ExApiService.get<any>(
      "auth/logout?Authorization=" + AccessToken + "&refresh_token=" + RefreshToken
    );
    // if (error) {
    //   return ErrorPopup(error);
    // }
    this.context.commit(ExMutations.LOGOUT);
  }
  @Action
  async [ExActions.UPDATE_USER]() {
    if (this.context.getters.isUserAuthenticated !== true) return;

    const [error, data] = await ExApiService.get("user/me");
    if (error) {
      return ErrorPopup(error);
    }
    this.context.commit(ExMutations.SET_USER, data.data);
  }
}
